import { AlternativeAutoComplete } from 'common/form/autoComplete/_alternativeAutoComplete'
import addressData from 'const/AdministrativeUnit/_data.json'
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import StringUtils from 'util/stringUtils'
import ArrayUtils from 'util/array'
import { StyledAddress } from './styled'
import { Text } from '../text'
import { THEME_SEMANTICS } from '../theme/_semantics'
import {AutoCompleteSingleOption} from "../form/autocompleteSingleOption";
import { AddressSplit } from './addressSplit'

export const provinceData = addressData.map(data => ({
  name: data?.name || '---',
  value: data?.id || '',
  id: data?.id || '',
  list: (data?.list || []).flatMap(district =>
    (district?.list || []).map(ward => ({
      value: ward.id,
      id: ward.id,
      name: ward.name,
    })),
  ),
}))

export const AddressBlock = ({ province, ward, district, showLabel = true, hiddenCategory = true, require=true, showAddressSplit = true, ...props }) => {
  const { t } = useTranslation()
  const [validateGroup, setValidateGroup]= useState('')
  const [validateProvince, setValidateProvince] = useState(province?.validate || '')
  const [validateWard, setValidateWard] = useState(ward?.validate || '')
  const [provinceKeyword, setProvinceKeyword] = useState('')
  const [provinceValue, setProvinceValue] = useState(null)
  const [provinceList, setProvinceList] = useState(provinceData || [])
  const [wardKeyword, setWardKeyword] = useState('')
  const [wardValue, setWardValue] = useState(null)
  const [wardList, setWardList] = useState([])
  const [wardListOrigin, setWardListOrigin] = useState([])

  const handleProvinceValidate = boo => {
    !!boo ? setValidateProvince('')
      : setValidateProvince(
      <div style={{ position: 'relative' }}>
            <span
              style={{ position: 'absolute', top: 0, left: 0, width: '200px' }}
            >
              {t('province_required')}
            </span>
      </div>
      )
  }
  const onProvinceKeywordChange = (data) => {
    const formatDataValue = data?.value
      ? StringUtils.removeAccents(data?.value?.toLowerCase())
      : ''

    const listData = provinceData.filter(item => {
      const formatNameItem = item?.name
        ? StringUtils.removeAccents(item.name.toLowerCase())
        : ''
      if (formatNameItem.includes(formatDataValue.trim())) return true
      return false
    })
    setProvinceKeyword(data?.value)
    setProvinceList(listData)
  }
  const onProvinceChange = (data) => {
    handleProvinceValidate(true)
    setProvinceValue(data)
    setWardList(
      ArrayUtils.getQualifiedArray(data?.list).map(
        (data) => (
          {
            name: data?.name || '---',
            value: data?.id || data?.value || '',
          }
        )
      )
    )
    setWardListOrigin(
      ArrayUtils.getQualifiedArray(data?.list).map(
        (data) => (
          {
            name: data?.name || '---',
            value: data?.id || data?.value || '',
          }
        )
      )
    )
    setWardValue(null)
    if (province?.onChange) province.onChange(data)
  }

  const handleWardValidate = boo => {
    !!boo ? setValidateWard('')
      : setValidateWard(
      <div style={{ position: 'relative' }}>
            <span
              style={{ position: 'absolute', top: 0, left: 0, width: '200px' }}
            >
              {t('ward_required')}
            </span>
      </div>
      )
  }
  const onWardKeywordChange = (data) => {
    setWardKeyword(data?.value)
    const formatDataValue = data?.value
      ? StringUtils.removeAccents(data?.value?.toLowerCase())
      : ''

    const listData = wardListOrigin.filter(item => {
      const formatNameItem = item?.name
        ? StringUtils.removeAccents(item.name.toLowerCase())
        : ''
      if (formatNameItem.includes(formatDataValue.trim())) return true
      return false
    })
    setWardList(listData)
  }
  const onWardChange = (data) => {
    handleWardValidate(true)
    setWardValue(data)
    if (ward?.onChange) ward.onChange(data)
  }

  useEffect(() => {
    if (province?.value?.value !== provinceValue?.value && +props?.unitVersion?.value === 1) {
      onProvinceChange(provinceData.find(item => +item?.value === +province?.value?.value))
    }
    if (ward?.value?.value !== wardValue?.value && +props?.unitVersion?.value === 1) {
      onWardChange(ward?.value)
    }
  }, [province?.value, ward?.value, props?.unitVersion])

  useEffect(() => {
    setValidateProvince(province?.validate)
    setValidateWard(ward?.validate)
    if(!!province?.validate || !!ward?.validate || !!props?.addressSplit?.validateText)
        setValidateGroup('address_incomplete')
    else setValidateGroup('')
  }, [province?.validate, ward?.validate, props?.addressSplit?.validateText])

  return (
    <StyledAddress>
      {/* {showAddressSplit && (
        <div style={{marginBottom: 16}}>
          <AddressSplit
            showLabel={showLabel}
            province={province}
            ward={ward}
            district={district}
            onChange={value => props?.addressSplit?.onChange(value)}
            onSetUnit={props?.onSetUnit}
            value={props?.addressSplit?.value}
            unitVersion={props?.unitVersion}
            validateText={props?.size === 'sm' ? props?.addressSplit?.validateText ? (<>&nbsp;</>) : '' : props?.addressSplit?.validateText}
          />
        </div>
      )} */}
      <div className="address-container" data-gap={props?.gap} data-block={!!props?.isBlock} data-size={props?.size}>
        <div className="province-container">
          <AlternativeAutoComplete
            {...props}
            // main input
            inputProps={{
              label: !!showLabel ? <Text>{t('city_name')} {!!require && <Text color={THEME_SEMANTICS.failed}>*</Text>}</Text> : '',
              categoryList: [], // menu list in category dropdown
              categoryValue: { name: t('city_name'), value: '' }, // if not exist this value -> default category: categoryList[0]
              categoryWidth: 140,
              categoryHidden: hiddenCategory,
              placeholder: t('select_province'),
              readOnly: true,
              value: provinceValue?.name || '',
              validateText: props?.size === 'sm' ? validateProvince ? (<>&nbsp;</>) : '' : validateProvince,
              validateType: 'danger',
            }}
            // search menu dropdown
            menuProps={{
              // style: {
              //   bottom: props?.placement === 'top' ? 40 : 'initial',
              //   top: props?.placement === 'top' ? 'initial' : 'calc(100% + 4px)',
              // },
              empty:
                provinceList.length <= 0 ? t('city_no_data') : '',
            }}
            // search input in dropdown menu
            searchInputProps={{
              placeholder: t('search_city'),
              value: provinceKeyword || '',
              onChange: onProvinceKeywordChange,
            }}
          >
            {provinceList.length > 0 &&
            provinceList.map(item => (
              <AutoCompleteSingleOption
                key={item.value}
                data-active={item.value === provinceValue?.value}
                onClick={() => onProvinceChange(item)}
              >
                {item.name}
              </AutoCompleteSingleOption>
            ))}
          </AlternativeAutoComplete>
        </div>
        <div className="ward-container">
          <AlternativeAutoComplete
            {...props}
            // main input
            inputProps={{
              label: !!showLabel ? <Text>{t('ward_name')}  {!!require && <Text color={THEME_SEMANTICS.failed}>*</Text>}</Text> : '',
              categoryList: [], // menu list in category dropdown
              categoryValue: { name: t('ward_name'), value: '' }, // if not exist this value -> default category: categoryList[0]
              categoryWidth: 140,
              categoryHidden: hiddenCategory,
              disabled: !!!provinceValue?.value,
              placeholder: t('select_ward'),
              readOnly: true,
              value: wardValue?.name || '',
              validateText: props?.size === 'sm' ? validateWard ? (<>&nbsp;</>) : '' : validateWard,
              validateType: 'danger'
            }}
            // search menu dropdown
            menuProps={{
              // style: {
              //   bottom: props?.placement === 'top' ? 40 : 'initial',
              //   top: props?.placement === 'top' ? 'initial' : 'calc(100% + 4px)',
              // },
              empty:
                wardList.length <= 0 ? t('ward_no_data') : '',
            }}
            // search input in dropdown menu
            searchInputProps={{
              placeholder: t('search_ward'),
              value: wardKeyword || '',
              onChange: onWardKeywordChange,
            }}
          >
            {wardList.length > 0 &&
            wardList.map(item => (
              <AutoCompleteSingleOption
                key={item.value}
                data-active={item.value === wardValue?.value}
                onClick={() => onWardChange(item)}
              >
                {item.name}
              </AutoCompleteSingleOption>
            ))}
          </AlternativeAutoComplete>
        </div>
          {
              props?.size === 'sm' && !!validateGroup && <div className='validate-group'>
                  <Text fontSize={12} color={THEME_SEMANTICS.failed}>{t(validateGroup)}</Text>
              </div>
          }
      </div>
    </StyledAddress>
  )
}